import axios from '@/utils/axios.js';

//校验是否重复提交
export function checkApplyRepeat(appointTime, ddbm) {
    return axios.get('/api/OutPatient/CheckDateTime?appointTime=' + appointTime  + '&old_ddbm=' + ddbm);
}